var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { T, t } from '../helpers/i18n';
import { Text, View } from './index';
import React, { Component } from 'react';
import cxs from 'cxs/component';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
let AvailableReserved = class AvailableReserved extends Component {
    render() {
        const { store, stretch } = this.props;
        const reserved = Number.isNaN(store.aforoStore.quantityUsed) ||
            store.aforoStore.quantityUsed === undefined
            ? ''
            : store.aforoStore.quantityUsed;
        const available = Number.isNaN(store.aforoStore.quantityAvailable -
            store.tempTicketStore.tempSaleTicket.quantityToAdd)
            ? ''
            : store.aforoStore.quantityAvailable -
                store.tempTicketStore.tempSaleTicket.quantityToAdd;
        const quantityAvailable = Number.isNaN(store.aforoStore.quantityAvailable)
            ? ''
            : store.aforoStore.quantityAvailable;
        const unitUsed = Number.isNaN(store.aforoStore.unitUsed) ? '' : store.aforoStore.unitUsed;
        const unitAvailable = Number.isNaN(store.aforoStore.unitAvailable) ? '' : store.aforoStore.unitAvailable;
        return (React.createElement(View, null,
            React.createElement(View, { flex: true, center: true, row: true, style: {
                    // paddingLeft: '15px',
                    justifyContent: 'space-around',
                    minHeight: '25px',
                } },
                React.createElement(WrapperText, { small: true }, `${t('capacity')}: ${stretch.capacity}`),
                stretch && !!!stretch.units && React.createElement(WrapperText, { small: true }, `${t('reserved')}: ${reserved !== null && reserved !== void 0 ? reserved : ''}`),
                React.createElement(WrapperText, { small: true }, `${t('available')} ${available} ${(available || available === 0) &&
                    (quantityAvailable || quantityAvailable === 0)
                    ? ' de'
                    : ' '} ${quantityAvailable !== null && quantityAvailable !== void 0 ? quantityAvailable : ''}`)),
            stretch && stretch.units && React.createElement(View, { flex: true, center: true, row: true, style: {
                    // paddingLeft: '15px',
                    justifyContent: 'space-around',
                    minHeight: '25px'
                } },
                React.createElement(WrapperText, { small: true }, `${T('total')} ${stretch.unitName}: ${stretch.units}`),
                React.createElement(WrapperText, { small: true }, `${t('reserved')}: ${unitUsed !== null && unitUsed !== void 0 ? unitUsed : ''}`),
                React.createElement(WrapperText, { small: true }, `${t('available')}: ${unitAvailable} `))));
    }
};
AvailableReserved = __decorate([
    inject('store'),
    observer
], AvailableReserved);
export default AvailableReserved;
const WrapperText = cxs(Text)({
    marginTop: 0,
    marginBottom: 0,
});
WrapperText.propTypes = {
    small: PropTypes.bool
};



//////////////////
// WEBPACK FOOTER
// ./src/elements/AvailableReserved.tsx
// module id = 562
// module chunks = 0